import * as React from "react";
import { Tabs, FormField, Textarea, Button, SpaceBetween } from "@amzn/awsui-components-react";
import { ContentEvaluationModel } from "../../model/content-evaluation-model";
import { FileUploadTab } from "./FileUploadTab";

export const ContentEvaluationForm: React.FC<ContentEvaluationModel.ContentEvaluationFormProps> = ({
    contentText,
    onContentTextChange,
    activeTabId,
    onTabChange,
    selectedFile,
    onFileChange,
    onSubmit,
    isSubmitting,
    onFlashbarUpdated
}) => {
    return (
        <SpaceBetween size="m">
            <Tabs
                activeTabId={activeTabId}
                onChange={({ detail }) => onTabChange(detail.activeTabId)}
                tabs={[
                    {
                        id: "text",
                        label: "Text Input",
                        content: (
                            <FormField
                                label="Content"
                                description="Enter content to evaluate"
                            >
                                <Textarea
                                    onChange={({ detail }) => onContentTextChange(detail.value)}
                                    value={contentText}
                                    placeholder="Enter content to evaluate..."
                                    rows={8}
                                />
                            </FormField>
                        )
                    },
                    {
                        id: "file",
                        label: "File Upload",
                        content: (
                            <FileUploadTab
                                selectedFile={selectedFile}
                                onFileChange={onFileChange}
                                onFlashbarUpdated={onFlashbarUpdated}
                            />
                        )
                    }
                ]}
            />

            <SpaceBetween direction="horizontal" size="xs">
                <Button
                    variant="primary"
                    onClick={onSubmit}
                    loading={isSubmitting}
                    disabled={(activeTabId === "text" && !contentText.trim()) ||
                            (activeTabId === "file" && !selectedFile)}
                >
                    Submit
                </Button>
            </SpaceBetween>
        </SpaceBetween>
    );
};
